import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  z-index: 100;
  top: 32px;
  right: 90px;
  display: flex;
  flex-direction: row;
`

export const Icon = styled.img`
  width: 30px;
  height: 30px;
  line-height: 40px;
  margin-right: 5px;
  margin-left: 5px;
  /* margin-top: -10px; */
`

export const Span = styled.span`
  display: flex;
  margin-left: 5px;
  span {
    color: ${({ theme }) => theme.primary};
    font-weight: 900;
  }
`

export const ContentHeader = styled.div`
  margin-bottom: 5px;

  display: flex;
  flex-direction: row;
  align-items: center;
`

export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
`

export const Minimize = styled.div`
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  margin-left: auto;
  border-radius: 10px;
  /* // box-shadow: 0 5px 14px rgba(0, 0, 0, 0.2); */

  :hover {
    transform: scale(1.02);
  }

  :active {
    transform: scale(0.98);
  }
`

export const ToggleButton = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  height: 40px;

  padding: 5px 15px 5px 15px;
  background: whitesmoke;

  box-shadow: ${({ showWarn }) => (showWarn ? '0px 0px 10px rgba(0, 0, 0, 0.2)' : '0px 0px 20px rgba(255, 0, 0, 0.7)')};

  font-weight: bold;
  border-radius: 20px;
  cursor: pointer;

  svg {
    color: ${({ theme, showWarn }) => (showWarn ? theme.primary : theme.danger)};
  }
  margin: 0 10px;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 300;
  transform: translateY(10px);
  position: absolute;
  bottom: 20px;
  right: 10px;
  background-color: white;
  width: 400px;
  height: 150px;
  border-radius: 25px;
  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.2);
  padding-left: 25px;
  padding-right: 25px;
  padding-top: 15px;
  padding-bottom: 10px;
`

export const InnerContent = styled.div`
  height: 300px;
`

export const WidgetWrapper = styled.div`
  height: 70px;
  background: #ffffff;
  box-shadow: 0px 8px 30px rgba(53, 88, 199, 0.22);
  display: flex;
  align-items: center;
  padding: 10px 5px;
  position: relative;
`

export const UploadDetails = styled.div`
  width: 100%;
`

export const ProgressBar = styled.div`
  width: 100%;
  height: 5px;
  border-radius: 10px;
  background: #e8eef4;
  margin-top: 20px;
  position: relative;

  div {
    width: ${({ percentage }) => `${percentage}%`};
    transition: width 1s;
    height: 100%;
    background: #f17d7d;
  }
`

export const NotUploading = styled.div`
  color: ${({ theme }) => theme.grey};
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const FileDetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
`

export const Procress = styled.div`
  font-size: 16px;
  margin-left: auto;
`

export const FileDetails = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  white-space: nowrap;
  width: 240px;
  height: 24px;
  display: block;
`

export const Divider = styled.div`
  border: 1px solid #2e2f33;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`
export const Alert = styled.div`
  color: ${({ theme }) => theme.danger};
  font-weight: 900;
`

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 24px;
  animation: fadeIn 0.2s ease-out;
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`

export const ModalContainer = styled.div`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.12), 0 8px 16px rgba(0, 0, 0, 0.08);
  max-width: 900px;
  width: 100%;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.25s ease-out;
  @keyframes slideUp {
    from { opacity: 0; transform: translateY(16px); }
    to { opacity: 1; transform: translateY(0); }
  }
`

export const ModalHeader = styled.div`
  padding: 20px 24px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
`

export const ModalTabs = styled.div`
  display: flex;
  gap: 4px;
  background: #f3f4f6;
  border-radius: 10px;
  padding: 4px;
`

export const ModalTab = styled.button`
  border: none;
  outline: none;
  cursor: pointer;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s ease;
  background: ${({ active }) => (active ? '#fff' : 'transparent')};
  color: ${({ active }) => (active ? '#1a1a1a' : '#888')};
  box-shadow: ${({ active }) => (active ? '0 1px 3px rgba(0,0,0,0.1)' : 'none')};

  &:hover {
    color: #1a1a1a;
  }
`

export const ModalClose = styled.button`
  border: none;
  outline: none;
  background: transparent;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  line-height: 1;
  color: #666;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  &:hover {
    background: rgba(0, 0, 0, 0.06);
    color: #1a1a1a;
  }
`

export const ModalBody = styled.div`
  padding: 20px 24px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  font-size: 14px;
  line-height: 1.7;
  color: #444;

  h1 {
    font-size: 20px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0 0 16px;
  }
  h2 {
    font-size: 16px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 20px 0 8px;
  }
  p {
    margin: 0 0 10px;
  }
  ol {
    padding-left: 20px;
    margin: 0 0 10px;
  }
  li {
    margin-bottom: 6px;
  }
`

export const ModalFooter = styled.div`
  padding: 16px 24px 20px;
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #f0f0f0;
`

export const ModalCloseBtn = styled.button`
  border: none;
  outline: none;
  cursor: pointer;
  padding: 10px 28px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  background: ${({ theme }) => theme.primary || '#2563eb'};
  transition: opacity 0.15s;
  &:hover {
    opacity: 0.9;
  }
`
